import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/usageOrderReport'
import Component from 'components/Reports/UsageOrderReport'

export default createListViewContainer({ actions, selectors: selectors.usageOrderReport })(Component)
